<template>
  <div class="resource">
  </div>
</template>
